import { useState, useEffect } from "react";
import { PlayersContext } from "./PlayersContext";

export function PlayersProvider({ children }) {
  const [playersData, setPlayersData] = useState([]);
  const [globalData, setGlobalData] = useState(null);

  const params = new URLSearchParams(window.location.search);
  const matchId = params.get("match") || "113503500599535529";

  useEffect(() => {
    const fetchInitialData = async () => {

      const delaySeconds = 35;
      const date = new Date(Date.now() - delaySeconds * 1000);
      const flooredSeconds = Math.floor(date.getSeconds() / 10) * 10;
      date.setSeconds(flooredSeconds);
      date.setMilliseconds(0);
      const time = date.toISOString();

        const response = await fetch(`https://feed.lolesports.com/livestats/v1/window/${matchId}?startingTime=${time}`);
        if (!response.ok) throw new Error("Erreur HTTP " + response.status);
        const data = await response.json();
        
        function mergeFirstFrameTeams(data) {
          const frame1 = data.frames[0]; // première frame

          return {
            gameState: frame1.gameState,
            patchVersion: data.gameMetadata.patchVersion,
            blueTeam: {
              ...frame1.blueTeam,
              ...data.gameMetadata.blueTeamMetadata
            },
            redTeam: {
              ...frame1.redTeam,
              ...data.gameMetadata.redTeamMetadata
            }
          };
        }

        // Utilisation
        const mergedGlobal = mergeFirstFrameTeams(data);
          
        mergedGlobal.blueTeam.name = mergedGlobal.blueTeam.participantMetadata[0].summonerName.split(" ")[0];
        mergedGlobal.redTeam.name = mergedGlobal.redTeam.participantMetadata[0].summonerName.split(" ")[0];

        console.log("mergedGlobal :",mergedGlobal);

        setGlobalData(mergedGlobal);

        const allPlayers = [
          ...data.gameMetadata.blueTeamMetadata.participantMetadata,
          ...data.gameMetadata.redTeamMetadata.participantMetadata,
        ];

        //on récupére les meme joueur dans la 2eme partie du tableau (pour l'hp)
        const otherPlayers = [
          ...data.frames[0].blueTeam.participants,
          ...data.frames[0].redTeam.participants,
        ];
        console.log("other:",otherPlayers);

        const otherPlayersMap = Object.fromEntries(
        otherPlayers.map(p => [p.participantId, p])
        );

        const merged = allPlayers.map(player => ({
        ...player,
        ...(otherPlayersMap[player.participantId] || {})  // ajoute les champs correspondants
        }));

        setPlayersData(merged);
        console.log("merged:");
        console.log(merged);

    };

    fetchInitialData();

    // --- Nouvelle partie : mise à jour périodique ---
    const interval = setInterval(fetchInitialData, 10000); // toutes les 10 secondes
    return () => clearInterval(interval); // nettoyage
  }, [matchId]);

  return (
    <PlayersContext.Provider value={{ playersData, globalData }}>
      {children}
    </PlayersContext.Provider>
  );
}
